import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.header.viewer');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrich-header-viewer',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichHeaderViewerComponent implements OnInit {
    @Input() title: string = '';
    @Input() currentPage: number = 0;
    @Input() totalPages: number = 0;
    @Output() pageChange = new EventEmitter<number>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public goBack() {
        window.history.back();
    }

    public prevPage() {
        if (this.currentPage > 1) {
            this.pageChange.emit(this.currentPage - 1);
        }
    }

    public nextPage() {
        if (this.currentPage < this.totalPages) {
            this.pageChange.emit(this.currentPage + 1);
        }
    }
}

export default PortalNrichHeaderViewerComponent;